import BaseState from "Engine/base/states/BaseState";
export default class ShowWonJackpotGameState extends BaseState {
}
